import React from 'react';

import {ProfileMenuContainer} from "../ProfileMenuContainer/ProfileMenuContainer";
import {Header} from "../../components/Header/Header";

export const CommonHeader = () => {
    return <Header><ProfileMenuContainer/></Header>
}